import React, { useState } from 'react';
import Modal from '../../../components/Modal/index';
import '../../../../sass/pages/list/promo_video_info_modal.scss';
import trackEvent from '../../../helpers/gtm/eventPush';

const PromoVideoInfoModal = ({ loginReturnPath, localisations }) => {
  const [showDialog, updateShowDialog] = useState(false);

  const close = () => {
    updateShowDialog(false);
  };

  const open = () => {
    trackEvent({
      category: 'pro_upgrade',
      action: 'promoted_video_info',
      label: `${loginReturnPath}`,
    });
    updateShowDialog(true);
  };

  const modalLabelText = <span>Get your video promoted</span>;
  const promoBadge = document.querySelectorAll(
    '.listing-card__promoted-video-info',
  );

  if (promoBadge.length) {
    promoBadge.forEach((button) =>
      button.addEventListener('click', (event) => {
        open();
        event.preventDefault();
      }),
    );
  }
  return (
    <>
      {showDialog ? (
        <Modal
          close={close}
          showDialog={showDialog}
          modalLabelText={modalLabelText}
          id="promoted_video_info-modal"
          initialFocus=".modal__close"
        >
          <div className="promo-video-modal">
            <p className="promo-video-modal__text">
              We believe that {localisations.flatshares} are all about the
              people and video gives you the quickest sense of whether you’d gel
              with them.
            </p>
            <p className="promo-video-modal__text">
              That’s why we’re giving free promotion to any videos that include
              the {localisations.flatmates}.
            </p>
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default PromoVideoInfoModal;
